import LikeArt from './LikeArt';

export default LikeArt;
